import { ReferenceType } from '@modules/client';

// spec: prefix all Enum types with a user-facing 'Enum.' prefix, e.g.
// 'Enum.Material'
const ENUM_PREFIX_LOWERCASED = 'enum.';
const prefixEnumIfEnum = (name: string, apiReferenceType: ReferenceType) => {
  if (apiReferenceType === ReferenceType.ENUM) {
    const trimmedName = name.toLowerCase().startsWith(ENUM_PREFIX_LOWERCASED)
      ? name.slice(ENUM_PREFIX_LOWERCASED.length)
      : name;
    return `Enum.${trimmedName}`;
  }
  return name;
};

export default prefixEnumIfEnum;
